export const TABLE_COMPLETED = 'completed';
export const TABLE_AWAITING_SIGNATURES = 'awaiting_signatures';

export const STEP_DETAILS = 'details';
export const STEP_TENANTS = 'tenants';
export const STEP_SUMMARY = 'summary';
export const STEP_SEND = 'send';

export const TENANT_TYPES = {
  STUDENT: 'Student',
  NON_STUDENT: 'Non-student',
  MIXED: 'Mixed',
};

export const UTILITY_GAS = 'Gas';
export const UTILITY_ELECTRICITY = 'Electricity';
export const UTILITY_INTERNET = 'Internet';
export const UTILITY_WATER = 'Water';
export const UTILITY_TV_LICENCE = 'TV Licence';
export const UTILITY_INSURANCE = 'Insurance';

export const DEFAULT_UTILITIES = [
  UTILITY_GAS,
  UTILITY_ELECTRICITY,
  UTILITY_INTERNET,
  UTILITY_WATER,
  UTILITY_TV_LICENCE,
];

export const VALID_UTILITY_COMBINATIONS = [
  DEFAULT_UTILITIES, // Gas, Electricity, Internet, Water, TV Licence
  [UTILITY_GAS, UTILITY_ELECTRICITY, UTILITY_INTERNET, UTILITY_WATER],
  [UTILITY_GAS, UTILITY_ELECTRICITY, UTILITY_INTERNET, UTILITY_TV_LICENCE],
  [UTILITY_GAS, UTILITY_ELECTRICITY, UTILITY_WATER, UTILITY_TV_LICENCE],
  [UTILITY_GAS, UTILITY_ELECTRICITY, UTILITY_WATER],
  [UTILITY_GAS, UTILITY_ELECTRICITY, UTILITY_TV_LICENCE],
];

export const UTILITIES_OPTION2 = [
  UTILITY_GAS,
  UTILITY_ELECTRICITY,
  UTILITY_WATER,
  UTILITY_TV_LICENCE,
];

export const UTILITIES_OPTION3 = [
  UTILITY_GAS,
  UTILITY_ELECTRICITY,
  UTILITY_INTERNET,
  UTILITY_WATER,
];

export const UTILITIES_OPTION4 = [
  UTILITY_GAS,
  UTILITY_ELECTRICITY,
  UTILITY_WATER,
];

export const UTILITIES_OPTION5 = [
  UTILITY_GAS,
  UTILITY_ELECTRICITY,
  UTILITY_INTERNET,
  UTILITY_TV_LICENCE,
];

export const UTILITIES_OPTION6 = [
  UTILITY_GAS,
  UTILITY_ELECTRICITY,
  UTILITY_TV_LICENCE,
];

export const UTILITIES_ICONS = {
  [UTILITY_GAS]: 'svg/uh-flame-icon.svg',
  [UTILITY_ELECTRICITY]: 'svg/uh-bolt-icon.svg',
  [UTILITY_INTERNET]: 'svg/uh-wifi-icon.svg',
  [UTILITY_WATER]: 'svg/uh-water-icon.svg',
  [UTILITY_TV_LICENCE]: 'svg/utilities/monitor-play.svg',
};

/** App\Enums\LettingAgent\HoldingAgreements\DepositAllocation */
export const DEPOSIT_ALLOCATION_PART_OF_TENANCY_DEPOSIT =
  'part_of_tenancy_deposit';
export const DEPOSIT_ALLOCATION_PART_OF_FIRST_RENT_INSTALMENT =
  'part_of_first_rent_instalment';

export const DEPOSIT_ALLOCATION_OPTIONS = [
  {
    id: DEPOSIT_ALLOCATION_PART_OF_TENANCY_DEPOSIT,
    value: DEPOSIT_ALLOCATION_PART_OF_TENANCY_DEPOSIT,
    label: 'Part of the tenancy deposit',
  },
  {
    id: DEPOSIT_ALLOCATION_PART_OF_FIRST_RENT_INSTALMENT,
    value: DEPOSIT_ALLOCATION_PART_OF_FIRST_RENT_INSTALMENT,
    label: 'Part of the first rent instalment',
  },
] as const;

export const MODAL_VOID = 'modal_void';
export const MODAL_SEND_REMINDERS = 'modal_send_reminders';
export const MODAL_TENANT = 'modal_tenant';
export const MODAL_UPLOAD = 'modal_upload';
export const MODAL_DELETE = 'modal_delete';

export const MODAL_TYPES = [
  MODAL_VOID,
  MODAL_SEND_REMINDERS,
  MODAL_TENANT,
  MODAL_UPLOAD,
  MODAL_DELETE,
];
